<template>
  <div class="main-bg">
    <div class="wrapper">
      <keep-alive>
        <router-view ref="childrenPage"/>
      </keep-alive>
    </div>
    <van-tabbar route placeholder safe-area-inset-bottom :fixed="true" @change="onChange">
      <van-tabbar-item replace to="/iframepagechanpin">
        <span>产品销售</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/iframepageyingyong">
        <span>技术资料</span>
        <template #icon="props">
          <img :src="props.active ? icon1.active : icon1.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/personalcenter">
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon3.active : icon3.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace>
        <span>运维服务</span>
        <template #icon="props">
          <img :src="props.active ? icon4.active : icon4.inactive" />
        </template>
      </van-tabbar-item>
      <!-- <van-tabbar-item replace to="/ai" v-if="this.userId">
        <span>AI助手</span>
        <template #icon="props">
          <img :src="props.active ? icon5.active : icon5.inactive" />
        </template>
      </van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>

<script>
import { getCookie } from '@/utils/auth'
export default {
  name: 'Layout',
  data () {
    return {
      userId: getCookie('userid'),
      icon1: {
        active: require('../../assets/img/tab-icon1-active.png'),
        inactive: require('../../assets/img/tab-icon1-inactive.png')
      },
      icon2: {
        active: require('../../assets/img/tab-icon2-active.png'),
        inactive: require('../../assets/img/tab-icon2-inactive.png')
      },
      icon3: {
        active: require('../../assets/img/tab-icon3-active.png'),
        inactive: require('../../assets/img/tab-icon3-inactive.png')
      },
      icon4: {
        active: require('../../assets/img/tab-icon4-active.png'),
        inactive: require('../../assets/img/tab-icon4-inactive.png')
      },
      icon5: {
        active: require('../../assets/img/tab-icon5-active.png'),
        inactive: require('../../assets/img/tab-icon5-inactive.png')
      }
    }
  },
  created () {
    setTimeout(() => {
      this.userId = getCookie('userid')
    }, 1000)
  },
  methods: {
    onChange (index) {
      if (index === 3) {
        this.go('/pages/iframeStation/index')
      }
    },
    go (url) {
      this.wx.miniProgram.navigateTo({
        url: url, // 小程序必须有该目录
        success () {
          console.log('跳转成功')
        },
        fail (err) {
          console.log('跳转失败', err)
        },
        complete () {
          console.log('执行')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.main-bg{
  height: 100%;
}
.wrapper{
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  height: calc(100% - 50px);
  width: 100%;
}
</style>
<style>
.van-tabbar-item{
  font-size: 12px !important;
}
.van-tabbar-item__text{
  margin-top: 3px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue